import { handleActions } from 'redux-actions';
import {
  fetchAvailableBadges,
  fetchAvailableBadgesSuccess,
  awardingBadge,
  awardBadgeSuccess,
  awardBadgeFail,
} from './actionCreators';
import { CoreBadgeStateSlice } from '../types';
import { reduxKey } from './constants';

const handler = handleActions<CoreBadgeStateSlice, any>(
  {
    [awardingBadge.toString()]: (
      state,
      action: ReturnType<typeof awardingBadge>
    ) => {
      return {
        ...state,
        isAwarding: true,
        errorMsg: undefined,
      };
    },
    [awardBadgeSuccess.toString()]: (
      state,
      action: ReturnType<typeof awardBadgeSuccess>
    ) => {
      return {
        ...state,
        isAwarding: false,
        errorMsg: undefined,
      };
    },
    [awardBadgeFail.toString()]: (
      state,
      action: ReturnType<typeof awardBadgeFail>
    ) => {
      return {
        ...state,
        isAwarding: false,
        errorMsg: action.payload.errorMsg,
      };
    },
    [fetchAvailableBadges.toString()]: (
      state,
      action: ReturnType<typeof fetchAvailableBadges>
    ) => {
      return {
        ...state,
        awardableBadges: {
          ...state.awardableBadges,
          [action.payload.userId]: {
            isLoading: true,
            results: [],
          },
        },
        errorMsg: undefined,
      };
    },
    [fetchAvailableBadgesSuccess.toString()]: (
      state,
      action: ReturnType<typeof fetchAvailableBadgesSuccess>
    ) => {
      return {
        ...state,
        awardableBadges: {
          ...state.awardableBadges,
          [action.payload.userId]: {
            isLoading: false,
            results: action.payload.results,
          },
        },
        gemRestrictions: action.payload.gemRestrictions,
      };
    },
  },
  {}
);

export default {
  [reduxKey as string]: handler,
};
